import { render, staticRenderFns } from "./MontageWasserIcon.vue?vue&type=template&id=355c9f00&scoped=true"
import script from "./MontageWasserIcon.vue?vue&type=script&lang=js"
export * from "./MontageWasserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c9f00",
  null
  
)

export default component.exports